var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3030_8692)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_3030_8692)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.42105C4 5.97937 5.97937 4 8.42105 4H15.5789C18.0206 4 20 5.97937 20 8.42105V15.5789C20 18.0206 18.0206 20 15.5789 20H8.42105C5.97937 20 4 18.0206 4 15.5789V8.42105ZM8.42105 5.26316C6.677 5.26316 5.26316 6.677 5.26316 8.42105V15.5789C5.26316 17.323 6.677 18.7368 8.42105 18.7368H15.5789C17.323 18.7368 18.7368 17.323 18.7368 15.5789V8.42105C18.7368 6.677 17.323 5.26316 15.5789 5.26316H8.42105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9582 15.5781C13.9115 15.5781 15.495 13.9946 15.495 12.0412C15.495 10.0879 13.9115 8.50437 11.9582 8.50437C10.0049 8.50437 8.42136 10.0879 8.42136 12.0412C8.42136 13.9946 10.0049 15.5781 11.9582 15.5781ZM11.9582 16.8412C14.6092 16.8412 16.7582 14.6922 16.7582 12.0412C16.7582 9.39024 14.6092 7.24121 11.9582 7.24121C9.30724 7.24121 7.1582 9.39024 7.1582 12.0412C7.1582 14.6922 9.30724 16.8412 11.9582 16.8412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.7581,
    cy: 8.08332,
    r: 0.842105,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3030_8692",
    x1: 1.52308,
    y1: 24,
    x2: 22.0615,
    y2: 1.75385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291672,
    stopColor: "#F3C82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357605,
    stopColor: "#FF1733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#492CFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC2C46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3030_8692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cd5e05c96edcd737dcbbd859043819ab.svg";
export { ForwardRef as ReactComponent };